import { Skeleton } from "@/components/ui/skeleton";

const PopularDestinationsSkeleton = () => {
  return (
    <div className="relative rounded-2xl overflow-hidden aspect-[3/4]">
      <Skeleton className="absolute inset-0 w-full h-full" />
      <div className="absolute bottom-4 left-4 right-4">
        <Skeleton className="h-6 w-32 bg-white/20" />
      </div>
    </div>
  );
};

export default PopularDestinationsSkeleton;
